import React from 'react';
import PropTypes from 'prop-types';
import { makeValidate } from 'mui-rff';

import { FormDialog } from 'components';
import getAddSettings from './getAddSettings';
import getEditSettings from './getEditSettings';
import { schema } from '../validation/appointmentAddDialog';
import AppointmentForm from './appointmentForm';
import { useTranslation } from 'react-i18next';

const validate = makeValidate(schema);

export function AppointmentDialog(props) {
  const { t } = useTranslation();
  const { close, isEditMode, isOpen, initialData } = props;

  const onSave = (values) => {
    let record = {
      title: t('New appointment'),
      users: [{
        id: values?.teamMember?.id,
        acceptOnBehalfOfPatient: values?.acceptOnBehalfOfPatient || false
      }],
      patient: values?.patient?.id || values?.patient,
      startDate: values?.date?.startDate,
      endDate: values?.date?.endDate,
      isRange: values?.isRange,
      planifiedDuration: values?.planifiedDuration,
      eventType: values.eventType,
      isOnline: values?.isOnline,
      locationId: !values?.isOnline ? values.locationId : undefined,
      reservationModeId: values?.reservationMode?.id,
      roomId: values?.room?.id,
      note: values?.note,
      files: values?.files,
    };

    close({ record });
  };

  const onDeleteEvent = () => {
    close();
    props.deleteDialog({ isEvent: false });
  };

  const dialogSettings = isEditMode
    ? getEditSettings({ ...props, deleteDialog: onDeleteEvent })
    : getAddSettings();

  return (
    <FormDialog
      onSubmit={onSave}
      validate={validate}
      onClose={close}
      contentStyle={{ overflowY: 'visible' }}
      initialValues={{
        ...initialData,
        isOnline: false,
      }}
      {...dialogSettings}
      {...props}
    >
      {(formValues, { form, errors }) => {
        return <AppointmentForm form={form} isEditMode={false} />;
      }}
    </FormDialog>
  );
}

AppointmentDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  open: PropTypes.func,
};

export default AppointmentDialog;
